/** Europe/Rome date helpers: display and admin input are always Italian time, storage is UTC. */
export const ROME_TZ = 'Europe/Rome';

// Backend sends UTC with "Z"; legacy values without offset are treated as UTC too.
export const parseUtc = (iso) => (iso ? new Date(/[zZ]|[+-]\d\d:?\d\d$/.test(iso) ? iso : `${iso}Z`) : null);

const PARTS = new Intl.DateTimeFormat('en-GB', {
	timeZone: ROME_TZ, hourCycle: 'h23',
	year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit',
});

function romeParts(date) {
	const o = {};
	PARTS.formatToParts(date).forEach((p) => { o[p.type] = p.value; });
	return o;
}

function romeOffsetMs(date) {
	const p = romeParts(date);
	const asUtc = Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour, +p.minute, +p.second);
	return asUtc - Math.floor(date.getTime() / 1000) * 1000;
}

// UTC ISO -> "YYYY-MM-DDTHH:mm" in Italian time (for <input type="datetime-local">).
export function utcToRomeInput(iso) {
	const d = parseUtc(iso);
	if (!d) return '';
	const p = romeParts(d);
	return `${p.year}-${p.month}-${p.day}T${p.hour}:${p.minute}`;
}

// "YYYY-MM-DDTHH:mm" Italian time -> UTC ISO. Ambiguous (DST end) -> ora solare; non-existent (DST start) -> +1h.
export function romeInputToUtc(local) {
	if (!local) return undefined;
	const [date, time] = local.split('T');
	const [y, m, d] = date.split('-').map(Number);
	const [hh, mi] = time.split(':').map(Number);
	const guess = Date.UTC(y, m - 1, d, hh, mi);
	const off1 = romeOffsetMs(new Date(guess));
	let t = guess - off1;
	const off2 = romeOffsetMs(new Date(t));
	if (off2 !== off1) t = guess - off2;
	return new Date(t).toISOString();
}

export const fmtRome = (iso, opts) => {
	const d = parseUtc(iso);
	return d ? d.toLocaleString('it-IT', { ...opts, timeZone: ROME_TZ }) : '';
};
